import { RemindMailTempModel } from "./vo/remind-mail-temp-model";

/**
 * 差し戻し理由入力画面の値を管理するクラス
 *
 * @export KYMW1707Model
 * @class KYMW1707Model
 */
export class KYMW1707Model {
  public supplierName: string = <string>'';
  public imageFileName: string = <string>'';
  public remindMailTempList: RemindMailTempModel[];
  public remindMailTempId: string = <string>'';
  public title: string = <string>'';
  public mainText: string = <string>'';
  public supplierAnnouncement: string = <string>'';
}
